import { Receipt } from 'lucide-react';

import { page, type DeclarationModule } from '@/app/moduleRegistry';

/**
 * Declaration du module Sales : devis, factures, avoirs, relances.
 *
 * `id` correspond a `SalesModule.CleModule` cote back. Le module regroupe devis et
 * factures sous une meme cle d'activation, comme au back : les deux forment une
 * seule tranche verticale, on n'active pas l'un sans l'autre.
 */
export const moduleSales: DeclarationModule = {
  id: 'sales',
  libelle: 'Devis & factures',
  icone: Receipt,
  ordre: 20,

  routes: [
    {
      chemin: 'devis',
      libelleNav: 'Devis',
      composant: page(() => import('./pages/ListesSalesPages')),
    },
    {
      chemin: 'devis/nouveau',
      roleRequis: 'Membre',
      composant: page(async () => ({
        default: (await import('./pages/FicheDevisPage')).NouveauDevisPage,
      })),
    },
    {
      chemin: 'devis/:devisId',
      composant: page(() => import('./pages/FicheDevisPage')),
    },
    {
      chemin: 'factures',
      estAccueil: true,
      libelleNav: 'Factures',
      composant: page(async () => ({
        default: (await import('./pages/ListesSalesPages')).ListeFacturesPage,
      })),
    },
    {
      chemin: 'factures/nouvelle',
      roleRequis: 'Membre',
      composant: page(async () => ({
        default: (await import('./pages/FicheFacturePage')).NouvelleFacturePage,
      })),
    },
    {
      chemin: 'factures/:factureId',
      composant: page(() => import('./pages/FicheFacturePage')),
    },

  ],
};
